import axios from "axios"
import store from "@/store"
// import qs from "qs"
// import router from '@/router'  //引入router
import { message } from 'ant-design-vue'
import publicJs from '@/utils/js/publicJs'
import NProgress from "nprogress"; // 加载进度条

/* 创建axios实例（可以进行统一配置请） */
let instance = axios.create({
    // baseURL: "/api/"
    timeout: 20000
});

/* 请求拦截器 */
instance.interceptors.request.use(
    config => {
        //hide为隐式请求
        config.hide || start()

        const mac = localStorage.getItem("mac")
        if(!mac){
            message.error("请先设置设备唯一标识!")
            return false
        }
        config.headers.mac = mac
        config.url = `${publicJs.getServerUrl()}${config.url}`
        const token = localStorage.getItem('token')
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = `${token}`  //请求头加上token
        }

        let postData = config.data
        if(config.dataType == 'json'){
            return config
        }
        if (config.method === 'post') { // post请求，把数据类型改为formData
            if (postData && Object.prototype.toString.call(postData) != '[object FormData]') {
                //不是formData 转换为fromData
                let formData = new FormData()
                Object.keys(postData).forEach(key => {
                    formData.append(key, postData[key])
                })
                config.data = formData
                // config.data = qs.stringify({
                //     ...postData //后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
                // })
            }
        }
        return config
    },
    err => {
        end()
        return Promise.reject(err)
    }
)

/* 响应拦截 */
instance.interceptors.response.use(
    response => {
        end()
        return new Promise((reslove, reject) => {
            //响应状态码
            const status = response.status;
            if (status === 200) {
                const result = response.data;
                const {status, msg} = result
                if(!status && status != 0){
                    //没有status属性 直接返回
                    reslove(result)
                    return
                }
                if(status === 0){
                    //返回成功
                    reslove(result)
                    return
                }
                
                switch(status){
                    case 701: //token验证失败
                        store.dispatch('logoutHandler')
                        message.error("登录失效，请重新登录！")
                        return
                }
                message.error(msg)
                //失败
                reject(result)
                return
            }
            //响应失败
            //hide为隐式请求
            response.config.hide || message.error("服务器异常，状态码：" + status)
            reject(response)
        })
    },
    //接口错误状态处理，也就是说无响应时的处理
    error => {
        end()
        //hide为隐式请求
        if(error?.response?.config?.hide){
            return Promise.reject(error) // 返回接口返回的错误信息
        }
        if(!error.response){
            message.error(`请求超时，请检查网络设置是否正确！`)
        } else {
            message.error(`请求失败，状态码：${error.response.status}`)
        }
        return Promise.reject(error) // 返回接口返回的错误信息
    }
)

//请求开始
function start(){
    //开启遮罩
    store.dispatch('showSpinning')
    //进度条开始
    NProgress.start()
}

//请求结束
function end(){
    //关闭遮罩
    store.dispatch('hideSpinning')
    //进度条结束
    NProgress.done()
}

export default instance